// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pjP6W","questions":"styles_questions__37wNK","footer":"styles_footer__1_byj"};